import styles from "./ViolenceAndHarassmentPolicyPage.module.css";

const ViolenceAndHarassmentPolicyPage = () => {
  return (
    <main className={styles.container} lang="el">
      <h1>
        ΠΟΛΙΤΙΚΗ ΚΑΤΑΠΟΛΕΜΗΣΗΣ ΒΙΑΣ KAI ΠΑΡΕΝΟΧΛΗΣΗΣ
      </h1>

      <h2>
        1.Εισαγωγή στις αρχές και δεσμεύσεις της εταιρείας για ένα εργασιακό περιβάλλον χωρίς βία και παρενόχληση.
      </h2>

      <p>
        Ο σεβασμός στα ανθρώπινα δικαιώματα και η δημιουργία ενός περιβάλλοντος ίσων ευκαιριών χωρίς βία και παρενόχληση στην εργασία διέπει όλες τις πολιτικές και τις διαδικασίες διαχείρισης του ανθρώπινου δυναμικού της εταιρείας. Η εταιρεία διασφαλίζει ένα εργασιακό περιβάλλον που σέβεται την ανθρώπινη αξιοπρέπεια, τη διαφορετικότητα και προωθεί το σεβασμό.
      </p>

      <p>
        1.1. Με την παρούσα πολιτική η εταιρεία The Records Hub S.A. υιοθετεί όλα τα μέτρα και τις υποχρεώσεις που αφορούν στην εφαρμογή των διατάξεων του Μέρους ΙΙ του ν. 4808/2021 για την πρόληψη και την αντιμετώπιση κάθε μορφής βίας και παρενόχλησης συμπεριλαμβανομένης της βίας και παρενόχλησης λόγω φύλου και της σεξουαλικής παρενόχλησης που εκδηλώνεται κατά τη διάρκεια της εργασίας είτε συνδέεται με αυτή.
      </p>

      <p>
        Η The Records Hub S.A, α) δηλώνει μηδενική ανοχή στη βία και παρενόχληση στην εργασία προσδιορίζοντας τα δικαιώματα και τις υποχρεώσεις των εργαζομένων των εργαζόμενων και των εργοδοτών στην εταιρεία και β) υιοθετεί διαδικασίες υποδοχής και εξέτασης των καταγγελιών αυτών με εμπιστευτικότητα και κατά τρόπο που διασφαλίζεται η του θύματος ο σεβασμός στην ανθρώπινη αξιοπρέπεια.
      </p>

      <h3>
        1.2.Πεδίο εφαρμογής της πολιτικής
      </h3>

      <p>
        Η παρούσα πολιτική ισχύει για όλους τους εργαζόμενους, στην εταιρεία The Records Hub S.A ακόμα και εκείνους των οποίων η σχέση εργασίας έχει καταγγελθεί, και αφορά σε περιστατικό που συνέβη στο διάστημα που ήταν σε ισχύ, ανεξαρτήτως του συμβατικού τους καθεστώτος, συμπεριλαμβανομένων των απασχολούμενων με σύμβαση έργου, ανεξαρτήτων υπηρεσιών, έμμισθης εντολής, των απασχολούμενων μέσω τρίτων παρόχων υπηρεσιών, καθώς και άτομα που παρακολουθούν κατάρτιση, συμπεριλαμβανομένων των ασκούμενων και των μαθητευόμενων, εθελοντών, συνεργατών, προμηθευτών, νεοεισερχόμενων, επισκεπτών καθώς και άτομα που αιτούνται εργασία.
      </p>

      <p>
        Οι μορφές συμπεριφοράς βίας και παρενόχλησης μπορούν να λαμβάνουν χώρα ιδίως:
      </p>

      <ol className={styles.labeledList}>
        <li>
          (i) στον χώρο εργασίας, συμπεριλαμβανομένων δημόσιων και ιδιωτικών χώρων και χώρων όπου ο εργαζόμενος παρέχει εργασία, λαμβάνει αμοιβή, κάνει διάλειμμα ιδίως, για ανάπαυση ή για φαγητό, σε χώρους ατομικής υγιεινής και φροντίδας, αποδυτηρίων ή καταλυμάτων που παρέχει ο εργοδότης,
        </li>
        <li>
          (ii) στις μετακινήσεις από και προς την εργασία, τις λοιπές επαγγελματικές μετακινήσεις, τα ταξίδια, την εκπαίδευση, καθώς και τις εκδηλώσεις και τις κοινωνικές δραστηριότητες που σχετίζονται με την εργασία και,
        </li>
        <li>
          (iii) κατά τις επικοινωνίες που σχετίζονται με την εργασία, συμπεριλαμβανομένων εκείνων που πραγματοποιούνται μέσω τεχνολογιών πληροφορικής και επικοινωνίας (π.χ. email, γραπτά μηνύματα, τηλ. επικοινωνίας κτλ.).
        </li>
      </ol>

      <h2>
        2.ΟΡΙΣΜΟΙ-ΕΝΝΟΙΕΣ:
      </h2>

      <h3>2.1.Βία και παρενόχληση:</h3>
      <p>
        Ως «βία και παρενόχληση» νοούνται οι μορφές συμπεριφοράς, πράξεις, πρακτικές ή απειλές αυτών, που αποσκοπούν, οδηγούν ή ενδέχεται να οδηγήσουν σε σωματική, ψυχολογική, σεξουαλική ή οικονομική βλάβη, είτε εκδηλώνονται μεμονωμένα είτε κατ’ επανάληψη.
      </p>

      <p>
        Στην ανωτέρω έννοια συμπεριλαμβάνονται ενδεικτικά μορφές συμπεριφοράς, που έχουν ως σκοπό ή αποτέλεσμα την παραβίαση της αξιοπρέπειας του προσώπου και τη δημιουργία εκφοβιστικού, εχθρικού ή επιθετικού περιβάλλοντος, ανεξαρτήτως εάν συνιστούν μορφή διάκρισης.
      </p>

      <p>
        Ενδεικτικά αναφέρουμε:
      </p>

      <ul>
        <li>
          επιθετική ή απειλητική συμπεριφορά, όπως φωνές, χειρονομίες, σπρώξιμο,
        </li>
        <li>
          διάδοση, γραπτώς ή προφορικώς, κακόβουλων και ανυπόστατων φημών για ένα άτομο ή μια ομάδα, αποκλείοντας κοινωνικά ή απομονώνοντας κάποιον,
        </li>
        <li>
          χρήση προσβλητικού χιούμορ, που περιλαμβάνει ρατσιστικά, μορφωτικά, θρησκευτικά, σεξιστικά αστεία ή αστεία με βάση την εθνότητα,
        </li>
        <li>
          υποτιμητικά σχόλια που αφορούν στο φύλο, τη φυλή, εθνότητα, εθνική καταγωγή, ηλικία, αναπηρία, μορφωτικό επίπεδο, θρησκεία, σεξουαλικό προσανατολισμό, ταυτότητα ή έκφραση φύλου ή σε οποιοδήποτε άλλο νομικά προστατευόμενο χαρακτηριστικό ενός άλλου προσώπου,
        </li>
        <li>
          δημόσια γελοιοποίηση άλλου προσώπου,
        </li>
        <li>
          υποτιμητικά σχόλια που αφορούν σωματικά ιδιαίτερα χαρακτηριστικά του ατόμου όπως π.χ. το βάρος, το ύψος, κλπ.,
        </li>
        <li>
          λήψη, ανάρτηση, προβολή, δημοσίευση, φωτογράφηση, εκτύπωση, διανομή πορνογραφικών, άσεμνων, προσβλητικών ή ανάρμοστων υλικών ή υλικών εθνικιστικού, θρησκευτικού ή ρατσιστικού χαρακτήρα,
        </li>
        <li>
          καταστροφή, απόκρυψη ή κλοπή προσωπικών αντικειμένων ή εξοπλισμού εργασίας,
        </li>
        <li>
          οπτικές μορφές παρενόχλησης, π.χ. αφίσες, κινούμενα σχέδια, γελοιογραφίες, φωτογραφίες ή σχέδια που είναι υποτιμητικά.
        </li>
        <li>
          αντεκδίκηση ή εκφοβισμός για την περίπτωση αναφοράς ή απειλής αναφοράς οποιασδήποτε από τις προαναφερθείσες μορφές παρενόχλησης ή για τη συνεργασία στη διερεύνηση περιστατικού παρενόχλησης.
        </li>
      </ul>

      <h3>2.2. Παρενόχληση:</h3>
      <p>
        Ως «παρενόχληση» νοούνται οι μορφές συμπεριφοράς, που έχουν ως σκοπό ή αποτέλεσμα την παραβίαση της αξιοπρέπειας του προσώπου και την δημιουργία εκφοβιστικού, εχθρικού, εξευτελιστικού, ταπεινωτικού ή επιθετικού περιβάλλοντος, ανεξαρτήτως εάν συνιστούν μορφή διάκρισης, και περιλαμβάνουν και την παρενόχληση λόγω φύλου ή για άλλους λόγους διάκρισης.
      </p>

      <h3>2.3. Παρενόχληση λόγω φύλου:</h3>
      <p>
        Ως «παρενόχληση λόγω φύλου» νοούνται οι μορφές συμπεριφοράς που συνδέονται με το φύλο ενός προσώπου, οι οποίες έχουν ως σκοπό ή αποτέλεσμα την παραβίαση της αξιοπρέπειας του προσώπου αυτού και την δημιουργία εκφοβιστικού, εχθρικού, εξευτελιστικού, ταπεινωτικού ή επιθετικού περιβάλλοντος.
      </p>

      <p>
        Ενδεικτικά αναφέρουμε:
      </p>

      <ul>
        <li>
          υποτιμητικά σχόλια ή αστεία σχετικά με το φύλο, την ταυτότητα του φύλου ή την έκφραση του φύλου ή τον σεξουαλικό προσανατολισμό,
        </li>
        <li>
          επιθετική συμπεριφορά λόγω φύλου, ταυτότητας φύλου, έκφραση φύλου ή σεξουαλικού προσανατολισμού.
        </li>
      </ul>

      <h3>2.4. Σεξουαλική παρενόχληση:</h3>
      <p>
        Ως «σεξουαλική παρενόχληση» ορίζεται η εκδήλωση οποιασδήποτε μορφής ανεπιθύμητης λεκτικής, ψυχολογικής ή σωματικής συμπεριφοράς σεξουαλικού χαρακτήρα, με αποτέλεσμα την προσβολή της προσωπικότητας ενός προσώπου, ιδίως με τη δημιουργία εκφοβιστικού, εχθρικού, εξευτελιστικού, ταπεινωτικού ή επιθετικού περιβάλλοντος γύρω από αυτό.
      </p>

      <p>
        Ενδεικτικά αναφέρουμε:
      </p>

      <ul>
        <li>
          σεξουαλικές προτάσεις, αιτήματα σεξουαλικών παραχωρήσεων ή ανεπιθύμητες απαιτήσεις για ραντεβού,
        </li>
        <li>
          προσφορά παροχών (π.χ. προαγωγή ή μισθολογική αύξηση) ως αντάλλαγμα για σεξουαλικές χάρες ή η δημιουργία περιβάλλοντος που προωθεί τη «σεξουαλική επαφή» ως μέσο για την επαγγελματική ανάπτυξη στο χώρο εργασίας,
        </li>
        <li>
          αποστολή σεξουαλικών/πορνογραφικών εικόνων, φωτογραφιών, κειμένων ή μηνυμάτων με e-mail ή με οποιονδήποτε άλλο μέσω επικοινωνίας (messenger, what’s app, κλπ.),
        </li>
        <li>
          σεξουαλικά υπονοούμενα, σχόλια, επίθετα, άσεμνες ή δυσφημιστικές εκφράσεις με σεξουαλικούς υπαινιγμούς, «πειράγματα» ή «αστεία» σεξουαλικού περιεχομένου,
        </li>
        <li>
          άσεμνες χειρονομίες, προβολή σεξουαλικά προσβλητικών γραφικών υλικών ηλεκτρονικής και έντυπης μορφής (e-mail, βιβλία, αρχεία, φωτογραφίες, κ.λπ.), γελοιογραφίες ή αφίσες, ή οποιοδήποτε υλικό με άσεμνους ή σεξουαλικούς υπαινιγμούς,
        </li>
        <li>
          ακατάλληλα ή μειωτικά σχόλια σχετικά με την εμφάνιση ή την ενδυμασία κάποιου προσώπου,
        </li>
        <li>
          ανεπιθύμητη σωματική επαφή, όπως αγγίγματα, χειρονομίες σεξουαλικής φύσεως,
        </li>
        <li>
          αντεκδίκηση ή απειλή για αντίποινα μετά από απόρριψη σεξουαλικών προτάσεων
        </li>
      </ul>

      <h3>2.5.Διάκριση:</h3>
      <p>
        Ως «διάκριση» νοείται η διαφορετική μεταχείριση των ανθρώπων που προκύπτει από προκαταλήψεις ή συμφέροντα, η κάθε πράξη με την οποία γίνεται αδικαιολόγητος διαχωρισμός ατόμων με βάση τις ομάδες, τις τάξεις ή άλλες κατηγορίες στις οποίες ανήκουν ή θεωρούνται ότι ανήκουν. Ενδεικτικά, διάκριση λόγω φύλου, ηλικίας, γλώσσας, εθνικότητας, φυλής ή εθνότητας, αναπηρίας, θρησκευτικών πεποιθήσεων ή σεξουαλικού προσανατολισμού.
      </p>

      <p>
        Ενδεικτικά αναφέρουμε:
      </p>

      <ul>
        <li>
          παρεμπόδιση της ανέλιξης προσώπου λόγω ηλικίας, φύλου, καταγωγής, θρησκείας, πολιτικών πεποιθήσεων,
        </li>
        <li>
          μη πρόσβαση προσώπου σε προνόμια και διευκολύνσεις προς όλο το προσωπικό λόγω φύλου, ηλικίας, σεξουαλικού προσανατολισμού, ταυτότητας φύλου, θρησκευτικών πεποιθήσεων.
        </li>
      </ul>

      <p>
        Τα παραπάνω παραδείγματα είναι ενδεικτικά και όχι εξαντλητικά των απαγορευμένων πράξεων που εμπίπτουν στους ορισμούς της βίας και παρενόχλησης.
      </p>

      <h2>
        3.Μέτρα για την αντιμετώπιση, την πρόληψη και την ευαισθητοποίηση του προσωπικού
      </h2>

      <p>
        Η εταιρεία δηλώνει μηδενική ανοχή στα φαινόμενα βίας και παρενόχλησης και υιοθετεί τις ακόλουθες διαδικασίες για την πρόληψη, την αντιμετώπιση και την ευαισθητοποίηση των φαινομένων βίας και παρενόχλησης στην εργασία:
      </p>

      <ol className={styles.labeledList}>
        <li>
          <p>
            α) ορίζει πρόσωπο ως αρμόδιο όργανο αναφοράς για τη διαχείριση των περιστατικών βίας.
          </p>
          <p>
            Ως «Αρμόδια Όργανα» νοούνται τα άτομα, οι ομάδες ή και τα τμήματα της που είναι υπεύθυνα να επιλαμβάνονται των αναφορών ή/και καταγγελιών αναφορικά με περιστατικά βίας ή παρενόχλησης στο χώρο εργασίας και να λαμβάνουν μέτρα πρόληψης και αντιμετώπισης τέτοιων περιστατικών.
          </p>
          <p>
            Για τους σκοπούς της παρούσας πολιτικής κάθε περιστατικό βίας και παρενόχλησης μπορεί να καταγγέλλεται είτε επώνυμα, είτε ανώνυμα είτε υιοθετώντας τις διαδικασίες διαχείρισης εσωτερικών καταγγελιών της εταιρείας επικοινωνώντας με τον ανεξάρτητο Σύμβουλο Ανθρώπινου Δυναμικού της Εταιρείας στο mail <a href="mailto:harassement@therecordshub.com">harassement@therecordshub.com</a> και στο τηλέφωνο 211 311 0874.
          </p>
        </li>
        <li>
          β) Υιοθετεί πολιτική για τη διαχείριση εσωτερικών περιστατικών καταγγελίας,
        </li>
        <li>
          γ)ενημερώνει τους εργαζόμενους για τη διαχείριση των περιστατικών βίας και παρενόχλησης,
        </li>
        <li>
          δ)παρέχει στους εργαζομένους πληροφορίες σχετικές με τους πιθανούς κινδύνους βίας και παρενόχλησης στον εργασιακό χώρο και με τα σχετικά μέτρα πρόληψης και προστασίας, συμπεριλαμβανομένων των υποχρεώσεων και των δικαιωμάτων των εργαζομένων και του εργοδότη επί τέτοιων περιστατικών,
        </li>
        <li>
          ε) αναρτά στον χώρο εργασίας και καθιστά προσβάσιμη ενημέρωση για τις διαδικασίες που υφίστανται σε επίπεδο επιχείρησης για την καταγγελία και την αντιμετώπιση τέτοιων μορφών συμπεριφοράς, καθώς και τα στοιχεία επικοινωνίας για τις αρμόδιες, σύμφωνα με τις κείμενες διατάξεις, διοικητικές και δικαστικές αρχές.
        </li>
        <li>
          στ) διοργανώνει ειδικά εκπαιδευτικά σεμινάρια και να οργανώνει εστιασμένες συζητήσεις για την πρόληψη και την αντιμετώπιση των φαινομένων βίας και παρενόχλησης στην εργασία.
        </li>
        <li>
          ζ)ενθαρρύνει τη συμμετοχή των εργαζομένων και των στελεχών της σε προγράμματα κατάρτισης και ευαισθητοποίησης σχετικά με την αναγνώριση, την πρόληψη και την αντιμετώπιση των κινδύνων βίας και παρενόχλησης στην εργασία.
        </li>
      </ol>

      <h3>
        Αρμόδια όργανα αναφοράς
      </h3>

      <p>
        Ο αρχικός παραλήπτης δεν πρέπει να προβεί σε καμία ενέργεια η οποία θα κάνει εμφανή τη γνώση του επί της καταγγελίας.
      </p>

      <p>
        Σε περίπτωση προφορικής αναφοράς ο καταγγέλλων προ τρέπεται να προχωρήσει εγγράφως και με λεπτομέρειες την αναφορά του δίνοντας τις σχετικές πληροφορίες.
      </p>

      <p>
        Την αξιολόγηση αυτών των αναφορών θα αναλάβει Ειδική Επιτροπή, την οποία απαρτίζουν:
      </p>

      <ol className={styles.labeledList}>
        <li>
          <p>
            α. Ο Γενικός Διευθυντής ή ο Προϊστάμενος του Τμήματος που έχει λάβει χώρα το περιστατικό o ανεξάρτητος Σύμβουλος Ανθρώπινου Δυναμικού , ο Σύμβουλος Νομικών Υποθέσεων της Εταιρείας
          </p>
          <p>
            Σε περίπτωση που η καταγγελία αφορά ένα από τα ανωτέρω πρόσωπα αυτό αποκλείεται από την Επιτροπή. από
          </p>
        </li>
        <li>
          β. Η ως άνω Επιτροπή διερευνά διεξοδικά την καταγγελία με αμεσότητα, εμπιστευτικότητα και διακριτικότητα και δύναται να καλεί σε ακρόαση κάθε εργαζόμενο της εταιρείας The Records Hub S.A. εφόσον μπορεί να έχει κάποια σχέση με το υπό κρίση περιστατικό. Σε όλες τις συναντήσεις που πραγματοποιούνται τηρούνται αναλυτικά πρακτικά.
        </li>
        <li>
          γ. Μετά το πέρας της εσωτερικής έρευνας του περιστατικού καταγγελίας συντάσσεται έκθεση με όλα τα δεδομένα και το αποτέλεσμα της έρευνας, το οποίο κοινοποιείται στα εμπλεκόμενα μέρη.
        </li>
      </ol>

      <p>
        Επίσης η εταιρεία The Records Hub S.A, πληροφορεί ότι υπάρχει δυνατότητα για την υποβολή καταγγελιών στις αρμόδιες αρχές :
      </p>

      <ul>
        <li>
          Στο Σώμα Επιθεώρησης Εργασίας (ΣΕΠΕ) κατ’ επιλογή του θιγομένου προσώπου είτε στον Προϊστάμενο της αρμόδιας Περιφερειακής Διεύθυνσης Επιθεώρησης Εργασιακών Σχέσεων, είτε στον Προϊστάμενο του αρμόδιου Τμήματος <a href="https://www.hli.gov.gr/ergasiakes-scheseis/nomothesia-ergasiakes-scheseis/prostasia/via-kai-parenochlisi-stin-ergasia/epilysi-diaforon-vias-kai-parenochlisis-enopion-tis-epitheorisis-ergasias/">https://www.hli.gov.gr/ergasiakes-scheseis/nomothesia-ergasiakes-scheseis/prostasia/via-kai-parenochlisi-stin-ergasia/epilysi-diaforon-vias-kai-parenochlisis-enopion-tis-epitheorisis-ergasias/</a>
        </li>
        <li>
          Στο Συνήγορο του Πολίτη: Χαλκοκονδύλη 17, 10432 Αθήνα, E-mail: <a href="mailto:press@synigoros.gr">press@synigoros.gr</a> Τηλ.: (+30) 213 1306 600
        </li>
        <li>
          τηλεφωνική γραμμή καταγγελιών ΣΕΠΕ (15512),
        </li>
        <li>
          υπηρεσία άμεσης ψυχολογικής υποστήριξης και συμβουλευτικής των γυναικών θυμάτων έμφυλης βίας που μπορούν να επικοινωνούν με την Γραμμή SOS 15900 (Γενική Γραμματεία Δημογραφικής και Οικογενειακής Πολιτικής και Ισότητας των Φύλων [Γ.Γ.Ι.Φ.],
        </li>
        <li>
          στα αρμόδια κατά τόπων και καθ’ ύλη δικαστήρια.
        </li>
      </ul>

      <p>
        Ο εργοδότης καθώς και κάθε Υπεύθυνο Πρόσωπο Αναφοράς συνεργάζονται με κάθε αρμόδια δημόσια. Διοικητική ή δικαστική αρχή, η οποία είτε αυτεπάγγελτα είτε κατόπιν αιτήματος από το θιγόμενο πρόσωπο αιτείται την παροχή στοιχείων και πληροφοριών και δεσμεύεται να παρέχει πρόσβαση και συνδρομή στα σχετικά στοιχεία.
      </p>

      <h2>
        4. Διαδικασία υποδοχής και εξέτασης καταγγελιών
      </h2>

      <p>
        Ο/η Εργαζόμενος/Εργαζόμενη που επιθυμεί να υποβάλει κάποια αναφορά ή καταγγελία για περιστατικό βίας, παρενόχλησης ή διάκρισης, το οποίο υπέστη εκείνος/εκείνη ή για το οποίο έλαβε άμεσα ή έμμεσα γνώση, μπορεί να απευθυνθεί στον Υπεύθυνο Διαχείρισης Αναφορών/Καταγγελιών βίας και παρενόχλησης.
      </p>

      <p>
        Ως Υπεύθυνος Διαχείρισης Αναφορών/Καταγγελιών βίας και παρενόχλησης ορίζεται ο ανεξάρτητος Σύμβουλος Ανθρώπινου Δυναμικού της εταιρείας ΤHE RECORDS HUB SA στο mail: <a href="mailto:harassement@therecordshub.com">harassement@therecordshub.com</a>
      </p>

      <h2>
        5. Διαδικασία διαχείρισης καταγγελιών για περιστατικά βίας ή/και παρενόχλησης
      </h2>

      <p>
        Η Επιτροπή θα διερευνήσει άμεσα και με εμπιστευτικότητα την καταγγελία, προστατεύοντας το απόρρητο και τα δικαιώματα τόσο του καταγγέλλοντος προσώπου, όσο και των λοιπών εμπλεκόμενων προσώπων και θα επιβάλλει τα κατάλληλα μέτρα, όπου αυτό απαιτείται.
      </p>

      <p>
        Η διαδικασία που ακολουθείται έχει ως εξής:
      </p>

      <ul>
        <li>
          Η ως άνω Επιτροπή διερευνά διεξοδικά την καταγγελία με αμεσότητα, εμπιστευτικότητα και διακριτικότητα και μπορεί να καλεί σε συνέντευξη κάθε εργαζόμενο της εταιρείας The Records Hub S.A, εφόσον μπορεί να έχει κάποια σχέση με το υπό κρίση περιστατικό. Σε όλες τις συναντήσεις που πραγματοποιούνται τηρούνται πρακτικά.
        </li>
        <li>
          Με την ολοκλήρωση της διαδικασίας, εφόσον το συμπέρασμα αυτής είναι ότι πράγματι υπήρξε περιστατικό βίας ή/και παρενόχλησης ή αντεκδίκησης, επιβάλλονται από την Εταιρεία οι σχετικές κυρώσεις σύμφωνα με το άρθρο 9 και τον Κανονισμό Εργασίας. Παράλληλα, προβαίνει σε ενέργειες αποκατάστασης υπέρ του θιγόμενου προσώπου (π.χ. προσωρινή αλλαγή της θέσης εργασίας εφόσον το αιτηθεί).
        </li>
      </ul>

      <h2>
        6. Μέτρα πρόληψης και προστασίας
      </h2>

      <p>
        Τα μέτρα πρόληψης και καταπολέμησης περιστατικών βίας, παρενόχλησης και διακρίσεων στην εργασία θα περιλαμβάνουν μεταξύ άλλων, τη διευκόλυνση αναφοράς τέτοιων περιστατικών, τη διερεύνηση και διαχείριση κάθε καταγγελίας ή αναφοράς με εμπιστευτικότητα, εχεμύθεια, αμεροληψία και σεβασμό στην ανθρώπινη αξιοπρέπεια.
      </p>

      <h3>
        α. Αξιολόγηση των παραγόντων κινδύνου και βελτίωση αυτών
      </h3>

      <p>
        Αποτελεί πρωταρχικό καθήκον και υποχρέωση της αρμόδιας επιτροπής και του τμήματος Ανθρώπινου Δυναμικού της εταιρείας The Records Hub S.A να παραλαμβάνει, να διερευνά και να διαχειρίζεται κάθε καταγγελία ή σχετική αναφορά, επιδεικνύοντας μηδενική ανοχή στη βία και παρενόχληση, με εμπιστευτικότητα, αμεροληψία και με τρόπο που σέβεται την ανθρώπινη αξιοπρέπεια και να μην παρεμποδίζει την παραλαβή, τη διερεύνηση και τη διαχείριση των καταγγελιών ή αναφορών αυτών.
      </p>

      <p>
        Καταγγελίες οι οποίες αποδεικνύεται ότι είναι καταφανώς κακόβουλες θεωρούνται απαράδεκτες και θα ερευνώνται περαιτέρω κατά την κρίση της εταιρείας, τόσο ως προς τα κίνητρα, όσο και ως προς τους εμπλεκομένους, προκειμένου να αποκατασταθεί η τάξη με κάθε νόμιμο τρόπο και μέσο.
      </p>

      <h3>
        β. Ενέργειες ενημέρωσης και ευαισθητοποίησης του προσωπικού
      </h3>

      <p>
        Με την κοινοποίηση της παρούσας επιδιώκεται:
      </p>

      <ol className={styles.labeledList}>
        <li>
          i. Η καλλιέργεια εργασιακού κλίματος με βασικές αξίες το σεβασμό, στην ανθρώπινη αξιοπρέπεια, τη συνεργασία και την αλληλοβοήθεια.
        </li>
        <li>
          ii. Η εταιρεία The Records Hub S.A τόσο κατά την πρόσληψη του προσωπικού του όσο και καθ’ όλο το χρονικό διάστημα της απασχόλησής του, δεσμεύεται να συνεχίζει να εκπονεί εκπαιδευτικά προγράμματα με στόχο την ενημέρωση, ευαισθητοποίηση και εν γένει καταπολέμηση και περιορισμό περιστατικών βίας, παρενόχλησης και διακρίσεων.
        </li>
        <li>
          iii. Ενθαρρύνει το προσωπικό να συνεργάζονται με τον/την Υπεύθυνο/η Διαχείρισης Αναφορών/Καταγγελιών βίας να καταρτίζει το προσωπικό της <strong><em>με περιοδικές καμπάνιες</em></strong> αναφορικά με τη σημασία της αρχής της ίσης μεταχείρισης, της απαγόρευσης των διακρίσεων, του σεβασμού της διαφορετικότητας, της προώθησης ενός πνεύματος ειλικρίνειας και διαλόγου και εν γένει της πρόληψης, αντιμετώπισης και καταπολέμησης της βίας και της παρενόχλησης στην εργασία.
        </li>
        <li>
          iv. Να προωθεί <strong><em>μέτρα για τον εντοπισμό των τομέων ή και των ειδικοτήτων, όπου οι εργαζόμενοι είναι περισσότερο εκτεθειμένοι</em></strong> σε περιστατικά βίας, παρενόχλησης και διακρίσεων, οπότε σε συνεργασία και με τους εκπροσώπους των εργαζομένων προβαίνει στις αναγκαίες ενέργειες προκειμένου να καλλιεργήσει στο προσωπικό της το αίσθημα της ασφάλειας, ώστε να μην φοβούνται να αποκαλύψουν περιστατικά βίας και παρενόχλησης στα οποία θύματα είναι οι ίδιοι ή συνάδελφοί τους.
        </li>
      </ol>

      <p>
        Αποτελεί πρωταρχικό καθήκον και υποχρέωση της The Records Hub S.A:
      </p>

      <ul>
        <li>
          να παρέχει συνδρομή και πρόσβαση σε κάθε αρμόδια δημόσια, διοικητική ή δικαστική αρχή, κατά την έρευνα τέτοιου είδους περιστατικού ή συμπεριφοράς, εφόσον ζητηθεί στην εταιρεία από αυτές τις αρχές,
        </li>
        <li>
          να παρέχει στους εργαζομένους πληροφορίες σχετικές με τους πιθανούς κινδύνους βίας και παρενόχλησης στον εργασιακό χώρο και με τα σχετικά μέτρα πρόληψης και προστασίας, συμπεριλαμβανομένων των υποχρεώσεων και των δικαιωμάτων των εργαζομένων και του εργοδότη επί τέτοιων περιστατικών,
        </li>
        <li>
          να ενημερώνει τους εργαζομένους της για τις διαδικασίες που υφίστανται σε επίπεδο επιχείρησης για την καταγγελία και την αντιμετώπιση τέτοιων μορφών συμπεριφοράς, προστατεύοντας τα προσωπικά δεδομένα σύμφωνα με τις οδηγίες GDPR, καθώς και τα στοιχεία επικοινωνίας για τις αρμόδιες, σύμφωνα με τις κείμενες διατάξεις, διοικητικές και δικαστικές αρχές.
        </li>
      </ul>

      <h3>
        γ) την απαγόρευση αντιποίνων σε βάρος του θιγόμενου προσώπου
      </h3>

      <p>
        Η Εταιρεία The Records Hub S.A δεσμεύεται ότι τηρεί την υποχρέωση απαγόρευσης αντιποίνων, σύμφωνα με το άρθρο 13 του ν. 4808/2021 και με τις διατάξεις της εργατικής νομοθεσίας και δεν προβαίνει σε δυσμενή μεταχείριση των θιγομένων προσώπων ως αντίμετρο για περιστατικό βία και παρενόχλησης.
      </p>

      <h3>
        δ. Πληροφορίες επί των δικαιωμάτων των θιγόμενων προσώπων
      </h3>

      <p>
        Κάθε εργαζόμενος ή με άλλη σχέση απασχολούμενος που θίγεται από περιστατικό βίας και παρενόχλησης σε βάρος του, ακόμη και αν έχει λήξει η σχέση, στο πλαίσιο της οποίας φέρεται ότι εκδηλώθηκε σε βάρος του το περιστατικό ή η συμπεριφορά, έχει δικαίωμα πέραν της δικαστικής προστασίας, να προσφύγει ενώπιον της Επιθεώρησης Εργασίας και του Συνηγόρου του Πολίτη σύμφωνα με τους Ν.3896/2010 και Ν.4443/2016 περί ίσης μεταχείρισης.
      </p>

      <p>
        Επίσης, το ίδιο ως άνω θιγόμενο πρόσωπο έχει δικαίωμα υποβολής σχετικής καταγγελίας εντός της επιχείρησης (αρθ. 10, Ν.4808/2021), οπότε και ο εργοδότης υποχρεούται να λάβει τα απαραίτητα πρόσφορα και ανάλογα μέτρα κατά περίπτωση σε βάρος του καταγγελλόμενου (είτε εργαζόμενος ή με άλλη σχέση απασχολούμενος, που παραβιάζουν την απαγόρευση βίας και παρενόχλησης) (αριθ. 12, παρ. 2, Ν.4808/2021).
      </p>

      <p>
        Τέλος, κάθε θιγόμενο πρόσωπο, εφόσον έχει εύλογη πεποίθηση ότι υφίσταται επικείμενος σοβαρός κίνδυνος για τη ζωή, την υγεία η την ασφάλειά του, έχει δικαίωμα να αποχωρήσει από τον εργασιακό χώρο για εύλογο χρόνο χωρίς στέρηση μισθού ή άλλη δυσμενή συνέπεια με την υποχρέωση προηγούμενης έγγραφης ενημέρωσης του εργοδότη, αναφέροντας το περιστατικό βίας και παρενόχλησης και τα περιστατικά που αιτιολογούν την πεποίθησή του. Εφόσον, όμως, έχει διερευνηθεί και η Επιτροπή έχει αποφανθεί ότι έχει παύσει να υφίσταται ο κίνδυνος και το θιγόμενο πρόσωπο αρνείται να επιστρέψει στον εργασιακό χώρο ο εργοδότης μπορεί να προσφύγει στην Επιθεώρηση Εργασίας με αίτημα την επίλυση της διαφοράς.
      </p>

      <h3>
        ε. Ενδοοικογενειακή βία - Προστασία της απασχόλησης και υποστήριξη εργαζόμενων θυμάτων ενδοοικογενειακής βίας
      </h3>

      <p>
        Ένα άλλο περιστατικό είναι η Ενδοοικογενειακή βία – Όλες οι πράξεις σωματικής, σεξουαλικής, ψυχολογικής ή οικονομικής βίας που λαμβάνουν χώρα μέσα στην οικογένεια, ανεξαρτήτως βιολογικών ή νομικών οικογενειακών δεσμών, ή μεταξύ πρώην ή νυν συζύγων ή συντρόφων και ανεξαρτήτως αν ο δράστης μοιράζεται ή μοιραζόταν στο παρελθόν την ίδια κατοικία με το θύμα. Η εταιρία εφόσον έρθει σε γνώση της περιστατικό ενδοοικογενειακής βίας δεσμεύεται να λαμβάνει κάθε πρόσφορο μέτρο και να προβαίνει σε κάθε εύλογη προσαρμογή των συνθηκών εργασίας με σκοπό την προστασία της απασχόλησης και την υποστήριξη των θυμάτων οικογενειακής βίας.
      </p>

      <h2>
        7.Yποχρεώσεις της εταιρείας
      </h2>

      <p>
        Όλα τα πρόσωπα που σχετίζονται με την εταιρεία με οποιαδήποτε σχέση ή σύμβαση εργασίας, οφείλουν να συμμορφώνονται με την παρούσα πολιτική και να απέχουν από κάθε πράξη βίας, εκφοβισμού και παρενόχλησης.
      </p>

      <p>
        Η Εταιρεία ενθαρρύνει τους θιγόμενους να κρατούν αρχείο με τα περιστατικά, που συνιστούν ενέργειες βίας και παρενόχλησης.
      </p>

      <p>
        Οι Προϊστάμενοι και οι Διευθυντές της Εταιρείας έχουν την αυξημένη ευθύνη να εκδηλώνουν οι ίδιοι υποδειγματική συμπεριφορά, καθώς και να φροντίζουν για την τήρηση της πολιτικής.
      </p>

      <h2>
        8.Προστασία του καταγγέλλοντος προσώπου
      </h2>

      <p>
        Προκειμένου να προστατέψει τους εργαζόμενους και να τους ενθαρρύνει να προβαίνουν σε καταγγελία των απαγορευμένων δια της παρούσης συμπεριφορών, η εταιρεία λαμβάνει τα ακόλουθα μέτρα:
      </p>

      <ol className={styles.labeledList}>
        <li>
          α. Απαγορεύεται και είναι άκυρη κάθε καταγγελία ή με οποιονδήποτε τρόπο λύση της έννομης σχέσης στην οποία στηρίζεται η απασχόληση, καθώς και κάθε άλλη δυσμενής μεταχείριση προσώπου που καλύπτεται από την παρούσα πολιτική, εφόσον συνιστά αυτή εκδικητική συμπεριφορά ή αντίμετρο (κατά την έννοια του αρθ. 14 του ν. 3896/2010) σε διαπιστωμένο περιστατικό βίας και παρενόχλησης, όπως αυτό ορίζεται στην παρούσα πολιτική.
        </li>
        <li>
          β. Απαγορεύεται ρητά οποιοδήποτε αντίποινο ή περαιτέρω θυματοποίηση του θιγόμενου προσώπου.
        </li>
        <li>
          γ. Η έρευνα και η εξέταση των καταγγελιών γίνεται πάντοτε με αμεροληψία και απόλυτη εμπιστευτικότητα ως προς όλα τα εμπλεκόμενα μέρη.
        </li>
      </ol>

      <h2>
        9. ΣΥΝΕΠΕΙΕΣ ΠΑΡΑΒΙΑΣΗΣ ΤΗΣ ΑΠΑΓΟΡΕΥΣΗΣ ΒΙΑΣ ΚΑΙ ΠΑΡΕΝΟΧΛΗΣΗΣ
      </h2>

      <p>
        Ανάλογα με τη βαρύτητα του καταγγελλόμενου περιστατικού και τις συνθήκες υπό τις οποίες έλαβε χώρα, η Εταιρεία υποχρεούται να λάβει τα αναγκαία πρόσφορα μέτρα προστασίας και κυρώσεις σε βάρος του καταγγελλόμενου προσώπου προκειμένου να εμποδισθεί και να μην επαναληφθεί παρόμοιο περιστατικό ή συμπεριφορά στο μέλλον.
      </p>

      <p>
        Οι κυρώσεις είναι ενδεικτικά και όχι περιοριστικά:
      </p>

      <ul>
        <li>
          Αλλαγή θέσης – τμήματος και αν υπάρχει δυνατότητα ωραρίου,
        </li>
        <li>
          Αλλαγή τόπου εργασίας
        </li>
        <li>
          προφορική παρατήρηση,
        </li>
        <li>
          προφορική επίπληξη, έγγραφη επίπληξη,
        </li>
        <li>
          υποχρεωτική αποχή έως δέκα (10) ημέρες από την Εταιρεία με στέρηση αποδοχών.
        </li>
        <li>
          Καταγγελία σύμβασης εργασίας
        </li>
      </ul>

      <h2>
        10. ΈΚΘΕΣΗ ΕΚΤΙΜΗΣΗΣ ΤΩΝ ΚΙΝΔΥΝΩΝ ΒΙΑΣ ΚΑΙ ΠΑΡΕΝΟΧΛΗΣΗΣ ΣΤΟ ΧΩΡΟ ΕΡΓΑΣΙΑΣ
      </h2>

      <p>
        Η σχετική έκθεση εκτίμησης των κινδύνων βίας και παρενόχλησης στην εργασία συντάσσεται και επικαιροποιείται σε συνεργασία με την Εταιρεία Υγιεινής και Ασφάλειας, οπότε και οι εργαζόμενοι ενημερώνονται για τους εκάστοτε κινδύνους που προέρχονται από την εργασία, μεταξύ των οποίων και τους κινδύνους βίας, παρενόχλησης και διακρίσεων, καθώς, επίσης, και για τους τρόπους πρόληψης αυτών (Βλέπε το συνημμένο στην παρούσα Παράρτημα 1).Ειδικότερα, έχουν εντοπιστεί και προστεθεί οι κίνδυνοι που συνδέονται με τη βία και παρενόχληση συμπεριλαμβανομένης της σεξουαλικής παρενόχλησης καθώς και μέτρα καταπολέμησης αυτών, λαμβάνοντας μεταξύ άλλων τα εξής:
      </p>

      <ul>
        <li>
          τη θέση εργασίας π.χ. επαφή με πελάτες ή κοινό
        </li>
        <li>
          παράγοντες όπως το φύλο και η ηλικία ή άλλα χαρακτηριστικά που αποτελούν λόγους διάκρισης.
        </li>
        <li>
          κίνδυνοι που αφορούν τις προδιαγραφές των χώρων εργασίας (π.χ φως στα γραφεία).
        </li>
      </ul>
    </main>
  );
};

export default ViolenceAndHarassmentPolicyPage;
